import {
  pgEnum
} from "drizzle-orm/pg-core";

// Enums
export const dutyTypeEnum = pgEnum("duty_type", ["appraisal", "field_adjusting", "sales", "desk_adjusting", "referral_fee", "director_of_appraisals", "administrative", "management"]);


// AI Agent Enums
export const agentTypeEnum = pgEnum("agent_type", ["compliance_sentinel", "intake_orchestrator", "document_specialist", "negotiation_partner", "financial_assistant"]);

export const agentRunStatusEnum = pgEnum("agent_run_status", ["queued", "running", "requires_approval", "completed", "failed", "cancelled"]);

export const agentActionTypeEnum = pgEnum("agent_action_type", ["tool_call", "decision", "recommendation", "alert", "task_creation", "draft_generation"]);


// More Enums
export const claimStatusEnum = pgEnum("claim_status", [
  "evaluation",
  "claim_accepted_sales", 
  "need_nts_repairability_video_sales",
  "need_pa_docs_returned_sales",
  "need_lor_emailed_to_ic_sales",
  "need_inspection_field",
  "need_measurements_field",
  "need_photos_field", 
  "need_quotes_invoices_ctr_field",
  "need_estimate_field",
  "need_pol_sent_to_ph_sales",
  "need_pol_returned_sales",
  "need_claim_package_uploaded_field",
  "need_estimate_review_optional",
  "notifying_insurance_send_claim_package_desk",
  "initial_negotiation_desk",
  "escalated_negotiations",
  "pending_1st_inspection_field",
  "pending_2nd_inspection_field", 
  "pending_engineer_inspection_field",
  "final_demand_desk",
  "doi_complaint_desk",
  "contractor_in_production_admin",
  "contractor_needs_supplement",
  "need_depreciation_released_desk",
  "pending_final_payment",
  "litigation",
  "appraisal_we_are_pa",
  "appraisal_file_we_are_appraiser",
  "on_hold",
  "collections_accounting",
  "need_to_close_claim",
  "needs_mgmt_review",
  "settled",
  "closed"
]);

export const perilTypeEnum = pgEnum("peril_type", ["fire", "water", "wind", "hail", "wind_hail", "tornado", "hurricane", "lightning", "smoke", "flood", "earthquake", "theft", "vandalism", "other"]);

export const inspectionStatusEnum = pgEnum("inspection_status", ["not_scheduled", "scheduled", "in_progress", "completed", "rescheduled", "cancelled"]);

export const accountingStatusEnum = pgEnum("accounting_status", [
  "no_accounting_activity",
  "create_invoice",
  "awaiting_settlement_check",
  "settlement_check_in_process",
]);

export const propertyTypeEnum = pgEnum("property_type", ["residential", "commercial", "industrial"]);

export const claimTypeEnum = pgEnum("claim_type", ["residential", "commercial"]);

export const contactTypeEnum = pgEnum("contact_type", [
  "claimant", "carrier", "contractor", "attorney", "engineer",
  "building_consultant", "other", "appraiser", "umpire",
  "field_adjuster", "desk_adjuster"
]);

export const contactEntityTypeEnum = pgEnum("contact_entity_type", ["company", "individual"]);

export const extractionStatusEnum = pgEnum("extraction_status", ["pending", "approved", "linked", "dismissed"]);

export const documentTypeEnum = pgEnum("document_type", [
  // Insurance Documents
  "policy", "declaration_page", "coverage_summary", "endorsement", 
  
  // Estimates and Assessments
  "estimate", "carrier_estimate", "contractor_estimate", "adjuster_estimate", "repair_estimate", "replacement_estimate",
  
  // Financial Documents  
  "invoice", "receipt", "payment_voucher", "check_copy", "bank_statement",
  
  // Communication
  "correspondence", "email", "letter", "notice", "demand_letter",
  
  // Evidence and Documentation
  "photo", "video", "damage_photo", "before_photo", "after_photo", "scene_photo",
  
  // Reports and Analysis
  "report", "inspection_report", "appraisal", "expert_report", "engineer_report", "medical_report",
  
  // Legal and Compliance
  "contract", "agreement", "legal_document", "court_filing", "subpoena",
  
  // Other
  "floor_plan", "blueprint", "warranty", "manual", "other"
]);

export const communicationTypeEnum = pgEnum("communication_type", ["email", "phone", "sms", "meeting", "letter"]);

export const estimateTypeEnum = pgEnum("estimate_type", ["contractor", "pa", "carrier"]);

export const paymentStatusEnum = pgEnum("payment_status", ["pending", "received", "disputed"]);

export const invoiceStatusEnum = pgEnum("invoice_status", ["draft", "sent", "paid", "overdue", "cancelled"]);

export const taskStatusEnum = pgEnum("task_status", ["pending", "in_progress", "completed", "cancelled"]);


export const adjusterLevelEnum = pgEnum("adjuster_level", ["regular", "senior", "director"]);

export const taskPriorityEnum = pgEnum("task_priority", ["low", "medium", "high", "urgent"]);

export const evaluationStatusEnum = pgEnum("evaluation_status", ["pending", "in_progress", "completed", "rejected", "requires_review"]);

export const evaluationTypeEnum = pgEnum("evaluation_type", ["pa", "appraisal", "consultation"]);

export const licenseStatusEnum = pgEnum("license_status", ["valid", "expired", "not_licensed", "pending"]);

export const exclusionTypeEnum = pgEnum("exclusion_type", ["cosmetic", "wind_driven_rain", "wear_tear", "maintenance", "flood", "earthquake", "other"]);


// Financial Management Enums
export const offerTypeEnum = pgEnum("offer_type", ["new_offer", "initial_offer", "prior_offer", "supplemental_offer"]);

export const policyCoverageEnum = pgEnum("policy_coverage", [
  "coverage_a_dwelling", "coverage_b_other_structures", "coverage_c_personal_property",
  "coverage_d_loss_of_use", "coverage_e_liability", "additional_coverage",
  "ale_additional_living_expense", "ordinance_and_law", "mold", "flood",
  "building", "bailee", "business_interruption", "business_property", "extra_expensive",
  "mitigation", "loss_of_income"
]);

export const paymentTypeEnum = pgEnum("payment_type", [
  "check", "cash", "invoice", "wire_transfer", "ach_transfer", 
  "direct_deposit", "electronic_transfer", "other_received"
]);

export const paymentProcessingStatusEnum = pgEnum("payment_processing_status", ["received", "pending", "void"]);

export const feeTypeEnum = pgEnum("fee_type", ["percent", "flat_rate", "hourly"]);

export const feeSourceEnum = pgEnum("fee_source", ["checks_payments", "settlement", "other"]);

export const expenseTypeEnum = pgEnum("expense_type", ["office_supplies", "travel", "professional_services", "consultant_fee", "software", "utilities", "equipment", "marketing", "other"]);

export const timeEntryTypeEnum = pgEnum("time_entry_type", ["field_work", "desk_work", "travel", "meeting", "phone_call", "research", "other"]);

export const timelineEventTypeEnum = pgEnum("timeline_event_type", [
  // Core claim events
  "claim_created", "claim_updated", "status_change", "adjuster_assigned", "claim_closed",
  "loss_occurred", "claim_filed",
  
  // Document events  
  "document_uploaded", "document_updated", "document_deleted", "document_approved",
  
  // Communication events
  "communication_sent", "communication_received", "email_sent", "email", "phone_call", "recording", "meeting_scheduled", "meeting_completed",
  
  // Financial events
  "estimate_received", "estimate_updated", "estimate", "offer_received", "offer_responded", "payment_received", "payment_processed", "payment", "invoice_created", "invoice_sent", "commission_calculated",
  
  // Task and workflow events
  "task_created", "task_assigned", "task_completed", "task_overdue", "deadline_approaching",
  
  // Inspection events
  "inspection", "inspection_scheduled", "inspection_completed",
  
  // AI and automation events
  "ai_draft_created", "ai_draft_approved", "ai_draft_rejected", "ai_status_update", "auto_reminder_sent", "intake_decision_automated",
  "ai_strategy", "ai_review", "ai_analysis", "ai_recommendation",
  "ai_generated", "ai_classification", "auto_classification",
  "agent_run", "agent_action", "compliance_sentinel", "weekly_ai_strategy_review",
  "weekly_status_update_sent",
  
  // Document folder events
  "folder_created",

  // User and manual events
  "user_note", "manual_update", "other",
  
  // Claim resolution events
  "denial", "settlement",
  
  // System and milestone events
  "milestone_reached", "system_notification", "user_login", "permission_changed", "contact_added", "contact_updated",
  "system_update", "auto_update", "webhook", "import",

  // Postal / certified mail events
  "postal_job_submitted", "postal_job_delivered", "postal_job_failed"
]);

export const roleTypeEnum = pgEnum("role_type", ["owner", "admin", "office_manager", "exec_pa", "accountant"]);


// Document Template Enums
export const documentTemplateStatusEnum = pgEnum("document_template_status", ["draft", "active", "archived", "deleted"]);

export const documentTemplateTypeEnum = pgEnum("document_template_type", [
  "welcome_letter", "representation_letter", "public_adjuster_agreement", 
  "property_inspection_report", "damage_assessment", "estimate_review",
  "carrier_correspondence", "settlement_letter", "closing_letter", "other"
]);

export const documentGenerationStatusEnum = pgEnum("document_generation_status", [
  "pending", "processing", "completed", "failed", "sent_to_docusign"
]);

export const docusignEnvelopeStatusEnum = pgEnum("docusign_envelope_status", [
  "draft", "sent", "delivered", "completed", "declined", "voided", "signed", "expired"
]);


// Lead management enums
export const leadStatusEnum = pgEnum("lead_status", ["new", "contacted", "qualified", "proposal_sent", "negotiating", "accepted", "rejected", "on_hold"]);

export const leadSourceEnum = pgEnum("lead_source", [
  "referral", "website", "phone_call", "email", "social_media",
  "advertising", "networking", "existing_client", "other",
  "ai_search", "google_search", "sponsored_ad", "email_smart_sync",
]);

export const leadCampaignEnum = pgEnum("lead_campaign", ["solar"]);

export const decisionTypeEnum = pgEnum("decision_type", ["public_adjuster", "appraiser", "consultation", "declined"]);


// PA assignment enums
export const paRoleEnum = pgEnum("pa_role", ["sales_pa", "field_pa", "desk_pa", "consultant", "other"]);


// AI Review enums
export const aiReviewChangeTypeEnum = pgEnum("ai_review_change_type", ["strategy_change", "no_change", "minor_update", "significant_change", "urgent_action_needed"]);


// File type enums - distinguish between PA files and Appraisal files
export const fileTypeEnum = pgEnum("file_type", ["public_adjuster", "appraisal", "estimate", "umpire", "other"]);

export const appraisalRoleEnum = pgEnum("appraisal_role", ["policyholder_appraiser", "carrier_appraiser", "umpire"]);

export const appraisalStatusEnum = pgEnum("appraisal_status", ["pending", "appraiser_selected", "umpire_selected", "in_progress", "award_issued", "completed", "withdrawn"]);


// Intake decision enums
export const negotiationStatusEnum = pgEnum("negotiation_status", ["early", "ongoing", "failed"]);

export const intakeDecisionPathwayEnum = pgEnum("intake_decision_pathway", [
  "pa_recommended",           // Public Adjuster service recommended
  "appraisal_recommended",    // Appraisal service recommended  
  "both_available",           // Both PA and Appraisal available
  "pa_only",                  // Only PA available (appraisal not allowed)
  "appraisal_only",           // Only Appraisal available (PA threshold not met)
  "not_qualified",            // Neither service available
  "requires_manual_review"    // Edge case requiring manual evaluation
]);

export const intakeDisqualificationReasonEnum = pgEnum("intake_disqualification_reason", [
  "loss_amount_too_low",
  "not_licensed_in_state", 
  "scope_dispute_in_restricted_state",
  "coverage_not_opened",
  "appraisal_not_applicable",
  "commercial_requirement_not_met",
  "other"
]);


// Appraisal workflow enums
export const appraisalWorkflowStatusEnum = pgEnum("appraisal_workflow_status", [
  "draft_awaiting_review",      // AI draft created, awaiting human approval
  "approved_pending_send",      // Human approved, scheduled to send
  "appraisal_initiated",        // Email sent, agreement sent, awaiting PH response
  "ph_agreement_signed",        // PH signed agreement
  "awaiting_carrier_response",  // Demand letter sent, waiting for carrier
  "carrier_accepted",           // Carrier accepted appraisal
  "carrier_rejected",           // Carrier rejected appraisal
  "appraiser_assigned",         // Appraisers assigned, in progress
  "educate_and_route",          // Carrier rejected, educating PH on options
  "completed",                  // Workflow complete
  "cancelled"                   // Workflow cancelled
]);

export const appraisalCarrierResponseEnum = pgEnum("appraisal_carrier_response", [
  "pending",
  "accepted",
  "rejected",
  "no_response"
]);

export const appraisalDocumentTypeEnum = pgEnum("appraisal_document_type", [
  "ph_explanation_email",       // Email to PH explaining decision/next steps
  "appraisal_demand_letter",    // Demand letter to carrier
  "mplc_ph_agreement",          // MPLC-PH appraisal agreement
  "appraiser_assignment_email", // Email to appraiser with details
  "education_options_email",    // Email explaining options after rejection
  "follow_up_email",            // Scheduled follow-up communications
  "reminder_email"              // Deadline reminders
]);


// Twilio Call System Enums
export const callSourceEnum = pgEnum("call_source", [
  "user_outbound",      // Human made call from CRM
  "inbound_forwarded",  // Received call forwarded to cell
  "email_uploaded",     // Recording sent via email
  "ai_agent",           // Future Retell.ai AI agent calls
  "manual_url"          // Manual URL transcription from claim timeline
]);

export const callStatusEnum = pgEnum("call_status", [
  "initiated",          // Call started
  "ringing",            // Phone is ringing
  "in_progress",        // Call connected
  "completed",          // Call ended normally
  "busy",               // Line was busy
  "no_answer",          // No one answered
  "failed",             // Call failed
  "cancelled"           // Call was cancelled
]);

export const callDirectionEnum = pgEnum("call_direction", ["inbound", "outbound"]);

export const transcriptionStatusEnum = pgEnum("transcription_status", [
  "pending",            // Waiting to be transcribed
  "processing",         // Transcription in progress
  "completed",          // Transcription complete
  "failed",             // Transcription failed
  "cancelled"           // Transcription cancelled by user
]);


// Follow-up watch status enum
export const repairFollowupStatusEnum = pgEnum("repair_followup_status", [
  "watching",           // Currently being watched, no reminder yet
  "reminder_pending",   // 30 days passed, awaiting acknowledgment
  "acknowledged",       // User acknowledged they contacted contractor/policyholder
  "auto_acknowledged",  // Auto-acknowledged via email sent
  "completed",          // Work complete, depreciation requested
  "cancelled"           // Watch cancelled (status changed to non-watched)
]);


// Follow-up event type enum
export const repairFollowupEventTypeEnum = pgEnum("repair_followup_event_type", [
  "watch_started",           // Claim entered watched status
  "reminder_triggered",      // 30 days elapsed, reminder sent
  "reminder_sent",           // Follow-up reminder notification sent
  "email_sent",              // Progress request email sent
  "auto_acknowledged",       // Auto-acknowledged via email
  "manually_acknowledged",   // User manually acknowledged
  "reply_received",          // Reply from contractor/policyholder received
  "work_complete_detected",  // AI detected work complete in reply
  "depreciation_alert",      // Alert to request depreciation
  "clarification_needed",    // Need more info about progress
  "watch_cancelled",         // Status changed, watch cancelled
  "watch_completed"          // Follow-up completed successfully
]);


// =====================
// Document Package System
// =====================

// Fee basis options for commission calculation
export const feeBasisEnum = pgEnum("fee_basis", [
  "entire_claim",           // Fee on entire claim (excluding ALE and deductible)
  "new_money_only",         // Fee only on recovered amounts beyond initial offer
  "entire_claim_minus_ale", // Entire claim minus Additional Living Expenses
  "custom"                  // Custom fee arrangement
]);


// Package generation status
export const packageGenerationStatusEnum = pgEnum("package_generation_status", [
  "pending",              // Waiting for user confirmation
  "validating",           // Running validation checks
  "validation_failed",    // Missing required data
  "generating",           // Generating documents
  "generated",            // Documents generated successfully
  "sending",              // Sending to DocuSign
  "sent",                 // Successfully sent to DocuSign
  "signed",               // All signatures collected
  "completed",            // Fully completed and processed
  "cancelled",            // Cancelled by user
  "error"                 // Error during processing
]);


// Document package document types - Standard document types for packages
export const documentPackageDocumentTypeEnum = pgEnum("document_package_document_type", [
  "welcome_letter",
  "pa_agreement",
  "notice_to_carrier",
  "letter_of_protection",
  "ink_document_1",
  "ink_document_2",
  "custom"
]);


// ============================================================================
// AI TRAINING CAPTURE SYSTEM - Automatic learning from user interactions
// ============================================================================

// AI Interaction Logs - Track all user interactions with AI features
export const aiInteractionTypeEnum = pgEnum("ai_interaction_type", [
  "draft_generated",
  "draft_edited",
  "draft_accepted",
  "draft_rejected",
  "suggestion_shown",
  "suggestion_accepted",
  "suggestion_rejected",
  "search_query",
  "search_refinement",
  "chat_message",
  "chat_correction",
  "feedback_positive",
  "feedback_negative",
  "document_classified",
  "document_analyzed",
  "estimate_compared"
]);


// AI Training Feedback - Direct user feedback with image/text for rapid AI training
export const aiTrainingFeedbackCategoryEnum = pgEnum("ai_training_feedback_category", [
  "document_analysis",
  "damage_assessment",
  "estimate_review",
  "compliance_detection",
  "email_classification",
  "contact_extraction",
  "general_correction",
  "other"
]);


// Edit reason categories for learning why users modify AI drafts
export const editReasonCategoryEnum = pgEnum("edit_reason_category", [
  "tone_adjustment",
  "factual_correction",
  "legal_compliance",
  "missing_information",
  "better_wording",
  "terminology_fix",
  "formatting",
  "policy_reference",
  "claim_specific_detail",
  "carrier_specific",
  "state_specific",
  "other"
]);


// ============================================
// LEGAL COMPLIANCE TRACKER TABLES
// ============================================

// Compliance requirement types
export const complianceRequirementTypeEnum = pgEnum("compliance_requirement_type", [
  "claim_acknowledgment",           // Carrier must acknowledge claim receipt
  "pol_submission_deadline",        // Policyholder POL submission deadline
  "pol_carrier_acknowledgment",     // Carrier must acknowledge POL receipt
  "investigation_completion",       // Carrier must complete investigation
  "affirm_deny_after_pol",          // Checkpoint 2: affirm/deny after Proof of Loss
  "investigation_status_letter",    // Checkpoint 3: recurring investigative status letter
  "decision_deadline",              // Carrier must issue coverage decision
  "undisputed_payment",            // Carrier must pay undisputed amounts
  "supplement_response",           // Carrier must respond to supplements
  "communication_response",        // Carrier must respond to communications
  "extension_notice",              // Carrier must provide extension notice if needed
  "denial_explanation",            // Carrier must provide written denial explanation
  "appraisal_demand_deadline",     // Deadline to demand appraisal
  "statute_of_limitations",        // Overall statute of limitations
  "depreciation_recovery"          // Depreciation recovery deadline
]);


// Compliance status
export const complianceStatusEnum = pgEnum("compliance_status", [
  "not_triggered",     // Requirement not yet applicable
  "upcoming",          // Within warning period
  "approaching",       // Within 7 days of deadline
  "due_today",         // Deadline is today
  "overdue",           // Past deadline, carrier in violation
  "completed",         // Requirement fulfilled
  "waived",            // Requirement waived or not applicable
  "breached"           // Confirmed carrier violation
]);


// AI Suggestion Feedback - Enum for feedback source types
export const aiFeedbackSourceTypeEnum = pgEnum("ai_feedback_source_type", [
  "stale_claim_recommendation",    // AI suggestions for stale claims
  "strategy_recommendation",       // AI strategy tab recommendations  
  "document_draft",               // AI-generated document drafts
  "ai_chat_response",             // AI chat assistant responses
  "compliance_suggestion",        // Compliance-related AI suggestions
  "email_draft",                  // AI-drafted emails
  "timeline_note_suggestion",     // AI-suggested timeline notes
  "lead_evaluation"               // AI lead evaluation results
]);


// ============================================================================
// QuickBooks Online Integration Tables
// ============================================================================

// QBO Sync Status Enum
export const qboSyncStatusEnum = pgEnum("qbo_sync_status", [
  "pending",      // Awaiting sync
  "syncing",      // Currently syncing
  "synced",       // Successfully synced
  "failed",       // Sync failed
  "skipped"       // Skipped (e.g., already up to date)
]);


// QBO Entity Type Enum
export const qboEntityTypeEnum = pgEnum("qbo_entity_type", [
  "customer",     // Policyholder → QBO Customer
  "vendor",       // Carrier/Contractor/Adjuster → QBO Vendor
  "invoice",      // Invoice → QBO Invoice
  "payment",      // Carrier Check → QBO Payment
  "bill",         // Commission → QBO Bill
  "bill_payment", // Commission Payment → QBO BillPayment
  "account"       // Chart of Accounts → QBO Account
]);


// ============================================================================
// Claim Photos - Photo Documentation System
// ============================================================================

// Photo Category Enum for organizing photos
export const photoCategory = pgEnum("photo_category", [
  "damage",           // Damage documentation
  "before",           // Before condition
  "after",            // After repair
  "progress",         // Work in progress
  "roof",             // Roof-specific
  "interior",         // Interior damage
  "exterior",         // Exterior damage
  "structural",       // Structural issues
  "water",            // Water damage
  "fire",             // Fire damage
  "general",          // General documentation
  "estimate",         // For estimate purposes
  "inspection",       // Inspection photos
  "repair",           // Repair/work in progress photos
  "documentation"     // General documentation photos
]);


// ============================================
// ADJUSTER PHONE DIRECTORY (Inbound Call Routing)
// ============================================

export const phoneDepartmentEnum = pgEnum("phone_department", ["adjuster", "insured", "portfolio", "partnership"]);


// ============================================================================
// Unified AI Corrections — Single table for ALL AI training feedback
// ============================================================================

export const aiCorrectionFeatureEnum = pgEnum("ai_correction_feature", [
  "photo_damage_analysis",
  "estimate_extraction",
  "document_drafting",
  "document_classification",
  "document_naming",
  "claim_evaluation",
  "ai_chat",
  "search",
  "task_suggestion",
  "policy_analysis",
  "email_classification",
  // Lead AI features
  "lead_evaluation",
  "lead_estimate_extraction",
  "lead_document_analysis",
  "intake_recommendation"
]);


export const aiCorrectionTypeEnum = pgEnum("ai_correction_type", [
  "correction",     // AI was wrong, here's the right answer
  "confirmation",   // AI was right (positive reinforcement)
]);


// ============================================================================
// Smart Email Pipeline — Processed Emails Table
// ============================================================================

export const processedEmailResultEnum = pgEnum("processed_email_result", [
  "matched_claim",     // Matched to existing claim
  "lead_created",      // Created new lead
  "skipped_noise",     // AI determined irrelevant (newsletter, spam, etc.)
  "skipped_duplicate", // Already processed (idempotency)
  "needs_review",      // Low confidence, pending human review
  "failed",            // Processing error
]);


export const processedEmailReviewStatusEnum = pgEnum("processed_email_review_status", [
  "not_needed",    // High confidence, no review required
  "pending",       // Awaiting human review
  "approved",      // Human approved AI result
  "corrected",     // Human corrected AI result
  "dismissed",     // Human dismissed (was noise)
]);

export const backgroundJobTypeEnum = pgEnum("background_job_type", ["email_sync", "attorney_export", "email_send", "docusign_send"]);
export const backgroundJobStatusEnum = pgEnum("background_job_status", ["running", "completed", "failed"]);

// Import Job Enums
export const importJobStatusEnum = pgEnum("import_job_status", [
  "parsing", "downloading", "processing", "matching", "review", "completed", "failed", "cancelled"
]);

export const importItemStatusEnum = pgEnum("import_item_status", [
  "pending", "downloading", "downloaded", "processing", "processed", "failed", "skipped"
]);

export const importGroupMatchStatusEnum = pgEnum("import_group_match_status", [
  "pending", "matched", "no_match", "ambiguous"
]);

export const importGroupActionEnum = pgEnum("import_group_action", [
  "pending", "link_existing", "create_new", "dismissed"
]);


// ============================================================================
// Postal / Certified Mail (Letterstream)
// ============================================================================

export const postalJobStatusEnum = pgEnum("postal_job_status", [
  "pending",      // Job created locally, not yet submitted to Letterstream
  "submitted",    // Submitted to Letterstream API, awaiting processing
  "in_transit",   // USPS picked up / in transit
  "delivered",    // Successfully delivered
  "returned",     // Returned to sender
  "failed",       // Submission or processing error
]);

export const postalMailClassEnum = pgEnum("postal_mail_class", [
  "first_class",         // Standard first class
  "certified",           // USPS Certified Mail
  "certified_err",       // Certified Mail + Electronic Return Receipt
]);


// Check Processing Desk (CPD) Enums
export const checkProcessingStageEnum = pgEnum("check_processing_stage", [
  "verify_check",
  "record_estimate",
  "submit_to_iink",
  "payment_commission",
  "completed"
]);
